import { RunningExperiments, useExperiments } from 'state/experiments';

export const useEnableMapListExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.MapList, 'treatment');
};
